module.exports = __webpack_public_path__ + "lb.5e6ca722.svg";